/**
 * Created by vaibhav on 31/3/18
 */
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import Img from 'gatsby-image';
import applemusicmono from '../img/logos/am-mono-black.svg';
import itunescolour from '../img/logos/itunes-colour.svg';
import spotifymono from '../img/logos/spotify-mono.svg';
import gpmcolour from '../img/logos/google-play-badge.png';

export const HomePageTemplate = ({
  title,
  heading,
  description,
  featuredImage,
  meta_title,
  meta_description,
}) => (
  <div>
    <Helmet>
      <title>{meta_title}</title>
      <meta name="description" content={meta_description} />
    </Helmet>
    <section className="hero hero-white">
      <div className="hero-body header-bgimage">
        <Img
          sizes={featuredImage.childImageSharp.sizes}
          imgStyle={{ objectPosition: 'center 20%', objectFit: 'cover' }}
          style={{
            background: `#ff0000`,
            backgroundSize: 'contain',
            color: '#fff',
            display: 'flex',
            height: '300px',
            height: '40vh',
            justifyContent: 'space-around',
            left: 0,
            position: 'absolute',
            top: 0,
            width: '100%',
            zIndex: -5,
          }}
        />
      </div>
    </section>
    <section className="body section is-paddingless">
      <div className="container">
        <div className="section">
          <div className="columns">
            <div className="column is-12 is-offset-2 slide-up">
              <div className="content column is-5">
                <h3 className="home-heading has-text-weight-bold">
                  <Link className="has-text-primary" to="/album">
                    {heading}
                  </Link>
                </h3>
                <p className="intro is-size-5">{description}</p>
              </div>
              <div className="block is-size-5" style={{ padding: '0.75rem' }}>
                <ul>
                  <li>
                    <a
                      href="https://geo.itunes.apple.com/au/album/borrowed-verse/1389719618?app=itunes"
                      target="_blank"
                    >
                      Purchase on iTunes
                    </a>{' '}
                  </li>
                  <li>
                    <a
                      href="https://play.google.com/store/music/album/Various_Artists_Borrowed_Verse?id=Bei5onqvevqmw2y5imcnblv4fte&hl=en"
                      target="_blank"
                    >
                      Purchase on Google Play Music
                    </a>{' '}
                  </li>
                  <li>
                    <a
                      href="https://geo.itunes.apple.com/au/album/borrowed-verse/1389719618?mt=1&app=music"
                      target="_blank"
                    >
                      Stream on Apple Music
                    </a>{' '}
                  </li>
                  <li>
                    <a
                      href="https://open.spotify.com/album/2p3V6iOLiNhLb3j9iAtlld?si=ZyV--JUeSJiTB85xRA1iag"
                      target="_blank"
                    >
                      Stream on Spotify
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="hero is-primary is-medium">
      <div class="hero-body" style={{ paddingTop: '7rem' }}>
        <div class="container">
          <Link className="" to="/darkmofo">
            <h3 class="title has-text-weight-normal home-heading is-primary">
              BORROWED VERSE at DARK MOFO 2018
            </h3>
            <h2 class="subtitle has-text-weight-normal is-italic">
              Info +{' '}
              <span
                style={{
                  textDecoration: `line-through`,
                }}
              >
                Tickets
              </span>
            </h2>
            <div className="is-italic is-size-6">Featuring:</div>
            <div class="column subtitle is-paddingless is-size-5">
              Tiny Ruins, Ben Salter, Angie Hart, <br />
              Emily Lubitz <small>(Tinpan Orange)</small>, Nausicaa, <br />
              David Stavanger, Graham Akhurst, Sophie Koh
            </div>
          </Link>
        </div>
      </div>
    </section>
  </div>
);

HomePageTemplate.propTypes = {
  title: PropTypes.string,
  meta_title: PropTypes.string,
  meta_description: PropTypes.string,
  featuredImage: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
};

const HomePage = ({ data }) => {
  const { frontmatter } = data.markdownRemark;

  return (
    <HomePageTemplate
      title={frontmatter.title}
      meta_title={frontmatter.meta_title}
      meta_description={frontmatter.meta_description}
      featuredImage={frontmatter.featuredImage}
      heading={frontmatter.heading}
      description={frontmatter.description}
    />
  );
};

HomePage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
};

export default HomePage;

export const pageQuery = graphql`
  query IndexPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        meta_title
        meta_description
        heading
        description
        featuredImage {
          childImageSharp {
            sizes(maxWidth: 1368, quality: 90) {
              ...GatsbyImageSharpSizes
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/home-page.js